import { render } from "./AziendaDettaglio.vue?vue&type=template&id=1ae4b9ac"
import script from "./AziendaDettaglio.vue?vue&type=script&lang=js"
export * from "./AziendaDettaglio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__